/**
 * Auth0 Configuration
 */
export const auth0Domain = process.env.REACT_APP_AUTH0_DOMAIN?.trim();
export const auth0ClientId = process.env.REACT_APP_AUTH0_CLIENT_ID?.trim();
export const auth0Audience = process.env.REACT_APP_AUTH0_AUDIENCE;
export const auth0RedirectUri =
  process.env.REACT_APP_AUTH0_REDIRECT_URI ||
  `${window.location.origin}/auth/callback`;
